var map = {
	"./cardano.png": 82,
	"./certik.png": 83,
	"./cosmos.png": 84,
	"./eos.png": 85,
	"./ethereum.png": 86,
	"./icon.png": 87,
	"./iost.png": 88,
	"./klaytn.png": 89,
	"./orbs.png": 90,
	"./proton.png": 91,
	"./qtum.png": 92,
	"./sentinel.png": 93,
	"./terra.png": 94,
	"./tgrade.png": 95,
	"./tron.png": 96,
	"./truechain.png": 97,
	"./ultra.png": 98,
	"./vsystems.png": 99,
	"./waves.png": 100,
	"./wax.png": 101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 199;